
import TileLayer from "ol/layer/Tile.js"
import WMTS from 'ol/source/WMTS.js';

import {globalProjection, globalTileGrid,urlGeoserver} from "./globals";

export const ignLayer = new TileLayer({
    source: new WMTS({
        url: 'https://data.geopf.fr/wmts',
        layer: 'HR.ORTHOIMAGERY.ORTHOPHOTOS',
        matrixSet: 'PM',
        format: 'image/jpeg',
        projection: globalProjection,
        tileGrid: globalTileGrid,
        style: 'normal',
        wrapX: true,
        crossOrigin: 'anonymous'
    }),
    visible:false,
    title:"Photos aériennes",
});

export const mntColorimetrieWmtsLayer = new TileLayer({
    source: new WMTS({
        url: urlGeoserver+"fond_de_plan/gwc/service/wmts",
        layer:'fond_de_plan:mnt_colorimetrie_masque',
        matrixSet: "WebMercatorQuad",
        format: 'image/png',
        projection: globalProjection,
        tileGrid: globalTileGrid,
        wrapX: true,
        crossOrigin: 'anonymous'
    }),
    visible:false,
    title:"Relief ombré couleur"
});

export const mntNbWmtsLayer = new TileLayer({
    source: new WMTS({
        url: urlGeoserver+"fond_de_plan/gwc/service/wmts",
        layer:'fond_de_plan:mnt_nb_masque',
        matrixSet: "WebMercatorQuad",
        format: 'image/png',
        projection: globalProjection,
        tileGrid: globalTileGrid,
        wrapX: true,
        crossOrigin: 'anonymous'
    }),
    visible:true,
    title:"Relief ombré N&B"
});

export const planIgnLayer = new TileLayer({
    source: new WMTS({
        url: 'https://data.geopf.fr/wmts',
        layer: 'GEOGRAPHICALGRIDSYSTEMS.MAPS.BDUNI.J1',
        matrixSet: 'PM',
        format: 'image/png',
        projection: globalProjection,
        tileGrid: globalTileGrid,
        style: 'normal',
        wrapX: true,
        crossOrigin: 'anonymous'
    }),
    visible:false,
    title:"Plan IGN",
});